module.exports = __webpack_public_path__ + "img/python_continuous_test_engine_mode.7e657f70.png";